import { BroadcastChannel, createLeaderElection } from 'broadcast-channel';

enum CUSTOM_EVENTS {
  CHAT_OPENED = 'chatOpened',
  CHAT_CLOSED = 'chatClosed',
  AGENT_TRANSFER = 'agentTransfer',
  AGENT_CONNECTED = 'agentConnected',
}

interface TransferInfo {
  transfer_id?: string;
  dialog_id?: string;
  agent_id?: string;
  agent_label?: string;
}

let isLeaderTab = false;
export const googleAnalytics = (gaEnabled: boolean) => {
  const analyticsChannel = new BroadcastChannel('analytics');
  const elector = createLeaderElection(analyticsChannel);
  elector.awaitLeadership().then(() => {
    isLeaderTab = true;
  });

  const sendCustomEvent = async (event: string, eventData: any) => {
    const hasLeader = await elector.hasLeader();

    if (gaEnabled && hasLeader && isLeaderTab) {
      // Check for Google Tag Manager script
      if (window.dataLayer.find(element => element['gtm.start'])) {
        window.dataLayer.push({ event, eventData });

        // Check for Global Site Tag (gtag.js) script
      } else if (window?.gtag && typeof window.gtag === 'function') {
        window.gtag('event', event, eventData);
      }
    }
  };

  const onChatOpened = (domain: string) => {
    sendCustomEvent(CUSTOM_EVENTS.CHAT_OPENED, { domain });
  };

  const onChatClosed = (domain: string) => {
    sendCustomEvent(CUSTOM_EVENTS.CHAT_CLOSED, { domain });
  };

  const onAgentTransfer = (domain: string) => {
    sendCustomEvent(CUSTOM_EVENTS.AGENT_TRANSFER, { domain });
  };

  const onAgentConnected = (transferInfo: TransferInfo, domain: string) => {
    sendCustomEvent(CUSTOM_EVENTS.AGENT_CONNECTED, {
      ...transferInfo,
      domain,
    });
  };

  return {
    onChatOpened,
    onChatClosed,
    onAgentTransfer,
    onAgentConnected,
  };
};
